"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AgeBasedTemplateIcon = AgeBasedTemplateIcon;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _translations = require("../helpers/translations");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/*
*
* AgeBasedTemplateIcon Component
*
*/
function AgeBasedTemplateIcon(_ref) {
  var color = _ref.color,
      width = _ref.width;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 100",
    width: width || '18px'
  }, /*#__PURE__*/_react["default"].createElement("title", null, (0, _translations.getTranslations)('btn_age_based_template')), /*#__PURE__*/_react["default"].createElement("path", {
    style: {
      fill: color || '#000'
    },
    d: "M 158 83 H 118 a 10 10 0 0 0 -10 10 l 0 80 a 10 10 0 0 0 10 10 H 178 a 10 10 0 0 0 10 -10 V 113 Z m -5 35 V 90.5 L 180.5 118 Z",
    transform: "translate(-108,-83)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    style: {
      fill: '#fff'
    },
    d: "M 167.3 167.7 h -8.8 l -3.5 -9.1 H 139 l -3.3 9.1 h -8.6 l 15.6 -40.1 h 8.6 Z m -14.9 -15.9 l -5.5 -14.9 l -5.4 14.9 Z",
    transform: "translate(-108,-83)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    style: {
      fill: '#fff'
    },
    d: "M 180.5 118 l -28 0 l 0 -28 Z",
    transform: "translate(-108,-83)"
  }));
}

AgeBasedTemplateIcon.propTypes = {
  color: _propTypes["default"].string,
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
var _default = AgeBasedTemplateIcon;
exports["default"] = _default;